const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//	REGISTER USER
		// ===================================
		case "REGISTRATION_IN_PROCESS":
			return {
				...getBasicState(state),
				inProcess: 1
			};
		case "REGISTRATION_HAS_ERROR":
			return {
				...state,
				inProcess: 0,
				error: action.error
			};
		case "REGISTRATION_SUCCESS":
			return {
				...state,
				success: action.data.data.message,
				inProcess: 0
			};

		case "REGISTRATION_RESULTS_CLEAR":
			return {
				...getBasicState(state)
			};

		// If a user logs out, we gotta clear this
		case "USER_LOGOUT":
			// Reviewers get the initial state, admins get the same deal cause maybe they are also reviewers...?
			let result = action.userType === "reviewer" ? { ...initialState } : { ...state };
			return {
				...result
			};

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */
function getBasicState(state) {
	const { error, success, ...newState } = state;
	return newState;
}





// WEBPACK FOOTER //
// ./src/store/reducers/registration.js